"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var errors_1 = require("@ledgerhq/errors");
var bignumber_js_1 = require("bignumber.js");
var address_1 = require("@celo/utils/lib/address");
var errors_2 = require("./errors");
var logic_1 = require("./logic");
var sdk_1 = require("./api/sdk");
var kit = (0, sdk_1.celoKit)();
// Arbitrary buffer for paying fees of next transactions. 0.05 Celo for ~100 transactions
var FEES_SAFETY_BUFFER = new bignumber_js_1.BigNumber(5000000000000000);
var getTransactionStatus = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, pendingOperationAmounts, lockedGold, nonvotingLockedGoldBalance, totalNonVotingLockedBalance, totalSpendableBalance, estimatedFees, amount, revoke, totalSpent, revoke;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                errors = {};
                warnings = {};
                useAllAmount = !!transaction.useAllAmount;
                if (account.freshAddress === transaction.recipient) {
                    errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                }
                if (!transaction.fees || !transaction.fees.gt(0)) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                pendingOperationAmounts = (0, logic_1.getPendingStakingOperationAmounts)(account);
                return [4 /*yield*/, kit.contracts.getLockedGold()];
            case 1:
                lockedGold = _d.sent();
                return [4 /*yield*/, lockedGold.getAccountNonvotingLockedGold(account.freshAddress)];
            case 2:
                nonvotingLockedGoldBalance = _d.sent();
                totalNonVotingLockedBalance = nonvotingLockedGoldBalance.minus(pendingOperationAmounts.vote);
                totalSpendableBalance = account.spendableBalance.minus(pendingOperationAmounts.lock);
                estimatedFees = transaction.fees || new bignumber_js_1.BigNumber(0);
                amount = new bignumber_js_1.BigNumber(0);
                if (useAllAmount &&
                    (transaction.mode === "unlock" || transaction.mode === "vote")) {
                    amount = totalNonVotingLockedBalance !== null && totalNonVotingLockedBalance !== void 0 ? totalNonVotingLockedBalance : new bignumber_js_1.BigNumber(0);
                }
                else if (useAllAmount && transaction.mode === "revoke") {
                    revoke = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
                    if (revoke === null || revoke === void 0 ? void 0 : revoke.amount)
                        amount = revoke.amount;
                }
                else if (useAllAmount) {
                    amount = totalSpendableBalance.minus(estimatedFees);
                }
                else {
                    amount = new bignumber_js_1.BigNumber(transaction.amount);
                }
                if (amount.lt(0))
                    amount = new bignumber_js_1.BigNumber(0);
                if (!errors.amount &&
                    (((_a = account.celoResources) === null || _a === void 0 ? void 0 : _a.lockedBalance.gt(0)) ||
                        !!((_c = (_b = account.celoResources) === null || _b === void 0 ? void 0 : _b.pendingWithdrawals) === null || _c === void 0 ? void 0 : _c.length)) &&
                    (transaction.useAllAmount ||
                        totalSpendableBalance.minus(amount).lt(FEES_SAFETY_BUFFER)) &&
                    ["send", "lock"].includes(transaction.mode)) {
                    warnings.amount = new errors_2.CeloAllFundsWarning();
                }
                if (!["register", "withdraw", "activate"].includes(transaction.mode)) {
                    if (amount.lte(0) && !useAllAmount) {
                        errors.amount = new errors_1.AmountRequired();
                    }
                }
                totalSpent = amount.plus(estimatedFees);
                if (transaction.mode === "unlock" || transaction.mode === "vote") {
                    if (totalNonVotingLockedBalance && amount.gt(totalNonVotingLockedBalance)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                    }
                }
                else if (transaction.mode === "revoke") {
                    revoke = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
                    if ((revoke === null || revoke === void 0 ? void 0 : revoke.amount) && amount.gt(revoke.amount))
                        errors.amount = new errors_1.NotEnoughBalance();
                }
                else {
                    if (totalSpent.gt(totalSpendableBalance)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                    }
                }
                if (!errors.amount && totalSpendableBalance.lt(estimatedFees)) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                if (transaction.mode === "send") {
                    if (!transaction.recipient) {
                        errors.recipient = new errors_1.RecipientRequired();
                    }
                    else if (!(0, address_1.isValidAddress)(transaction.recipient)) {
                        errors.recipient = new errors_1.InvalidAddress("", {
                            currencyName: account.currency.name
                        });
                    }
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map